import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5bc28e3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-row" }
const _hoisted_2 = { class: "strategy-name" }
const _hoisted_3 = {
  class: "table",
  style: {"overflow":"hidden","border-radius":"var(--el-border-radius-large)","border":"1px solid var(--el-border-color-base)"}
}
const _hoisted_4 = { class: "defence-list" }
const _hoisted_5 = {
  key: 0,
  class: "defence-item"
}
const _hoisted_6 = { class: "gray-column" }
const _hoisted_7 = { class: "content-column" }
const _hoisted_8 = {
  key: 1,
  class: "defence-item"
}
const _hoisted_9 = { class: "gray-column" }
const _hoisted_10 = { class: "content-column" }
const _hoisted_11 = {
  key: 2,
  class: "defence-item"
}
const _hoisted_12 = { class: "gray-column" }
const _hoisted_13 = { class: "content-column" }
const _hoisted_14 = {
  key: 3,
  class: "defence-item"
}
const _hoisted_15 = { class: "gray-column" }
const _hoisted_16 = { class: "content-column" }
const _hoisted_17 = {
  key: 4,
  class: "defence-item"
}
const _hoisted_18 = { class: "gray-column" }
const _hoisted_19 = { class: "content-column" }
const _hoisted_20 = {
  key: 5,
  class: "defence-item"
}
const _hoisted_21 = { class: "gray-column" }
const _hoisted_22 = { class: "content-column" }
const _hoisted_23 = {
  key: 6,
  class: "defence-item"
}
const _hoisted_24 = { class: "gray-column" }
const _hoisted_25 = { class: "content-column" }
const _hoisted_26 = {
  key: 7,
  class: "defence-item"
}
const _hoisted_27 = { class: "gray-column" }
const _hoisted_28 = { class: "content-column" }
const _hoisted_29 = {
  key: 8,
  class: "defence-item"
}
const _hoisted_30 = { class: "gray-column" }
const _hoisted_31 = { class: "content-column" }
const _hoisted_32 = {
  key: 9,
  class: "defence-item"
}
const _hoisted_33 = { class: "gray-column" }
const _hoisted_34 = { class: "content-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_GroupPolicyDrawer = _resolveComponent("GroupPolicyDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "destroy-on-close": "",
      modelValue: _ctx.modalVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalVisible) = $event)),
      "before-close": _ctx.closeModal,
      width: "550px"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.modalTitle), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.strategyNameLine), 1),
          _createElementVNode("span", {
            class: "cm-link-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showGroupPolicyDrawer && _ctx.showGroupPolicyDrawer(...args)))
          }, _toDisplayString(_ctx.$t('groupClient.defencePolicyView')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.columnTitles.virus_detection), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('groupClient.defencePolicySwitchOn')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.columnTitles.system_protection), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('groupClient.defencePolicySwitchOn')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.columnTitles.regular_exam), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.strategy?.regular_exam?.main_switch
                ? _ctx.$t('groupClient.defencePolicySwitchOn')
                : _ctx.$t('groupClient.defencePolicySwitchOff')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.columnTitles.regular_scan), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.strategy?.regular_scan?.main_switch
                ? _ctx.$t('groupClient.defencePolicySwitchOn')
                : _ctx.$t('groupClient.defencePolicySwitchOff')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.row.system_type === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.columnTitles.regular_scan), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.strategy?.regular_anti_virus_linux?.main_switch
                ? _ctx.$t('groupClient.defencePolicySwitchOn')
                : _ctx.$t('groupClient.defencePolicySwitchOff')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type) && 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.columnTitles.flow_control), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.strategy?.flow_control?.switch
                ? _ctx.$t('groupClient.defencePolicySwitchOn')
                : _ctx.$t('groupClient.defencePolicySwitchOff')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.columnTitles.early_warning), 1),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('groupClient.defencePolicyEarlyWarnOn', { n: _ctx.calcEarlyWarnCount() })), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.columnTitles.leak_repair), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.strategy?.leak_repair?.repair_task_main_switch
                ? _ctx.$t('groupClient.defencePolicyLeakRepairOnScheduled')
                : _ctx.$t('groupClient.defencePolicyLeakRepairOffScheduled')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.row.system_type === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.columnTitles.leak_repair), 1),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.strategy?.leak_repair_linux?.repair_task_main_switch
                ? _ctx.$t('groupClient.defencePolicyLeakRepairLinuxOn')
                : _ctx.$t('groupClient.defencePolicyLeakRepairLinuxOff')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.Windows_Platform.includes(_ctx.row.system_type))
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.columnTitles.baseline_check), 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.strategy?.baseline_check?.main_switch
                ? _ctx.$t('groupClient.defencePolicySwitchOn')
                : _ctx.$t('groupClient.defencePolicySwitchOff')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_GroupPolicyDrawer, {
      modelValue: _ctx.groupPolicyDrawerVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.groupPolicyDrawerVisible) = $event)),
      "policy-id": _ctx.defenceStrategy?.strategy_id,
      "operate-type": "read"
    }, null, 8, ["modelValue", "policy-id"])
  ], 64))
}